module.exports = __webpack_public_path__ + "media/images/error/404-b76a1b655c0df592c439b0cea081a8c3.png";